import InternalBanner from '../../../src/components/InternalBanner'
import ComingUpCarousel from './components/ComingUpCarousel'
import HomeContent from '../../../src/components/SectionContent'
import RecentlyReleasedGrid from './components/RecentlyReleased'
import { COMING_UP_FEATURES } from './config/comingUpFeatures'
import { RECENTLY_RELEASED_ITEMS } from './config/recentlyReleased.config'

const HomeFeaturesPage = () => {
  return (
    <>
      <InternalBanner
        title="New features"
        description="  Check out our recently released improvements and hear what's in the pipeline for
          Resilience Explorer®"
      />
      <div className="bg-neutral-200 pt-4 pb-10">
        <HomeContent>
          <ComingUpCarousel items={COMING_UP_FEATURES} />
        </HomeContent>
      </div>
      <HomeContent className="pb-10">
        <RecentlyReleasedGrid items={RECENTLY_RELEASED_ITEMS} />
      </HomeContent>
    </>
  )
}

export default HomeFeaturesPage
